import styled from "styled-components";

export const Title = styled.h1`
  font-size: 24px;
  margin: 0;
  padding: 0;
`;
